import { render, staticRenderFns } from "./PiechowiakFormView.vue?vue&type=template&id=da0087e4"
import script from "./PiechowiakFormView.vue?vue&type=script&lang=js"
export * from "./PiechowiakFormView.vue?vue&type=script&lang=js"
import style0 from "./PiechowiakFormView.vue?vue&type=style&index=0&id=da0087e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports